(() => {
  if (customElements.get('collection-shopping-controls')) return;
  customElements.define('collection-shopping-controls', class extends HTMLElement {
    connectedCallback() {
      this.ready = () => this.setup();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.ready, {once:true});
      else this.setup();
    }
    setup() {
      this.cleanup();
      const grid = this.closest('.collection-shopping-grid');
      const menu = grid?.querySelector('#open_filters_menu');
      if (!grid || !menu) return;
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      // Keep the controls above Shopify's own preview bar when reviewing a draft.
      const positionPreviewControls = () => {
        const previewBar = document.getElementById('PBarNextFrameWrapper');
        const rect = previewBar?.getBoundingClientRect();
        const offset = rect?.height && rect.top > innerHeight / 2 ? Math.max(0, innerHeight - rect.top) : 0;
        grid.style.setProperty('--collection-preview-offset', `${offset}px`);
        if (previewBar && this.previewBar !== previewBar) {
          this.previewBar = previewBar;
          this.previewObserver?.disconnect();
          this.previewObserver = new ResizeObserver(positionPreviewControls);
          this.previewObserver.observe(previewBar);
        }
      };
      this.previewBar = null;
      positionPreviewControls();
      this.bodyObserver = new MutationObserver(positionPreviewControls);
      this.bodyObserver.observe(document.body, {childList:true});
      window.addEventListener('resize', positionPreviewControls, options);
      const button = menu.querySelector('.open_filters');
      const drawer = menu.querySelector('.facets-menu');
      const sort = menu.querySelector('#SortBy');
      if (sort) sort.setAttribute('aria-label', 'Sort products');
      // Reuse the theme's filter form and native sort control, including AJAX updates.
      if (button && drawer) {
        button.setAttribute('role', 'button');
        button.setAttribute('aria-controls', 'collection-shopping-filters');
        button.setAttribute('aria-haspopup', 'dialog');
        drawer.id = 'collection-shopping-filters';
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        drawer.setAttribute('aria-label', 'Filter products');
        let wasOpen = false;
        const syncMenu = () => {
          const open = menu.classList.contains('show_menu');
          button.setAttribute('aria-expanded', String(open));
          drawer.inert = !open;
          if (open && !wasOpen) drawer.querySelector('.facets-menu__close')?.focus();
          if (!open && wasOpen) button.focus({preventScroll:true});
          wasOpen = open;
        };
        syncMenu();
        this.menuObserver = new MutationObserver(syncMenu);
        this.menuObserver.observe(menu, {attributes:true, attributeFilter:['class']});
        button.addEventListener('keydown', event => {if (event.key === ' ') {event.preventDefault();button.click();}}, options);
        document.addEventListener('keydown', event => {
          if (!menu.classList.contains('show_menu')) return;
          if (event.key === 'Escape') {event.preventDefault();event.stopPropagation();menu.querySelector('.facets-menu__close').click();}
          if (event.key === 'Tab') {
            const focusable = [...drawer.querySelectorAll('a[href],button,input,select,summary,[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
            const first = focusable[0], last = focusable.at(-1);
            if (!drawer.contains(document.activeElement)) {event.preventDefault();(event.shiftKey ? last : first)?.focus();return;}
            if (event.shiftKey && document.activeElement === first) {event.preventDefault();last?.focus();}
            else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first?.focus();}
          }
        }, options);
      }
      this.gridObserver = new IntersectionObserver(([entry]) => {
        grid.classList.toggle('collection-shopping-controls-visible', entry.isIntersecting);
      }, {threshold:0});
      this.gridObserver.observe(grid);
    }
    cleanup() { this.events?.abort();this.gridObserver?.disconnect();this.menuObserver?.disconnect();this.previewObserver?.disconnect();this.bodyObserver?.disconnect(); }
    disconnectedCallback() { document.removeEventListener('DOMContentLoaded', this.ready);this.cleanup(); }
  });
})();
